import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {GroupModel} from '@/libs/Api';
import {GroupsDataService} from '@/libs/groups/groups-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const groupsStore = registerCrudStore<GroupModel, GroupModel>(BusinessModule.Group, new GroupsDataService());
